export const getDeliveryDealerForPostcode = (postcode, deliveryPoints) => {
  return deliveryPoints.find(point =>
    point.assignedPostCodes.includes(postcode)
  );
};
